import { Outlet } from "react-router-dom";
import { LeadDialogProvider } from "../context/LeadDialogContext";
import { SettingsProvider } from "../context/SettingsContext";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

export default function PublicLayout() {
  return (
    <SettingsProvider>
      <LeadDialogProvider>
        <Navbar />
        <main>
          <Outlet />
        </main>
        <Footer />
      </LeadDialogProvider>
    </SettingsProvider>
  );
}
